import React from 'react';
import { ExternalLink } from 'lucide-react';
import type { FormField, RedirectUrlConfig, ThemeConfig } from '../../../types/forms';

interface RedirectUrlFieldProps {
  field: FormField;
  disabled?: boolean;
  themeConfig?: ThemeConfig;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- themeConfig reservado pra futuro uso (OQ1=b Pax); icons semânticos intocados (OQ2=a)
export const RedirectUrlField: React.FC<RedirectUrlFieldProps> = ({ field, themeConfig: _themeConfig }) => {
  const config = field.config as RedirectUrlConfig | undefined;
  const url = config?.url || '';
  const delay = config?.delay ?? 0;
  const openInNewTab = config?.openInNewTab ?? false;

  return (
    <div className="py-6 flex flex-col items-center gap-3">
      <div className="w-14 h-14 rounded-full bg-primary-500/20 flex items-center justify-center">
        <ExternalLink className="w-7 h-7 text-primary-400" />
      </div>
      <p className="text-lg font-medium" style={{ color: 'inherit' }}>
        {field.label}
      </p>
      {url ? (
        <p className="text-sm truncate max-w-xs" style={{ color: 'inherit', opacity: 0.5 }}>
          {url}
        </p>
      ) : (
        <p className="text-sm italic" style={{ color: 'inherit', opacity: 0.4 }}>
          Nenhuma URL configurada
        </p>
      )}
      <div className="flex items-center gap-3 text-xs" style={{ color: 'inherit', opacity: 0.4 }}>
        {delay > 0 && <span>Delay: {delay}s</span>}
        {openInNewTab && <span>Nova aba</span>}
      </div>
    </div>
  );
};
